export const apiStatus = {
  success: 200,
  notFound: 404,
  paymentInProcess: 402,
  notAcceptable: 406,
};
